export const isNoInternetConnectionError = (
  error:
    | {
        message: string;
      }
    | null
    | undefined
) => {
  return (
    (error?.message.includes('Failed to fetch') || // Chromium
      error?.message.includes('NetworkError when') || // Firefox
      error?.message.includes('network connection was lost') || // Safari
      error?.message.includes('Load failed') || // Safari 17+
      error?.message.includes('The Internet connection')) ??
    false
  );
};
